module.exports = __webpack_public_path__ + "static/media/blueSMS.5b0a9620.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blueSMS.svg
// module id = 454
// module chunks = 0